/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCorporateFareIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-corporate-fare"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M2.8 22.95Q1.68 22.95 0.91 22.19Q0.15 21.43 0.15 20.3L0.15 3.7Q0.15 2.58 0.91 1.81Q1.68 1.05 2.8 1.05L9.75 1.05Q10.88 1.05 11.64 1.81Q12.4 2.58 12.4 3.7L12.4 5.85L21.2 5.85Q22.32 5.85 23.09 6.61Q23.85 7.38 23.85 8.5L23.85 20.3Q23.85 21.43 23.09 22.19Q22.32 22.95 21.2 22.95ZM2.8 20.3L9.75 20.3L9.75 18.15L2.8 18.15ZM2.8 15.5L9.75 15.5L9.75 13.35L2.8 13.35ZM2.8 10.65L9.75 10.65L9.75 8.5L2.8 8.5ZM2.8 5.85L9.75 5.85L9.75 3.7L2.8 3.7ZM12.4 20.3L21.2 20.3L21.2 8.5L12.4 8.5ZM15.88 13.3Q15.32 13.3 14.94 12.91Q14.55 12.53 14.55 11.97Q14.55 11.43 14.94 11.04Q15.32 10.65 15.88 10.65L17.82 10.65Q18.38 10.65 18.76 11.04Q19.15 11.43 19.15 11.97Q19.15 12.53 18.76 12.91Q18.38 13.3 17.82 13.3ZM15.88 18.15Q15.32 18.15 14.94 17.76Q14.55 17.38 14.55 16.82Q14.55 16.27 14.94 15.89Q15.32 15.5 15.88 15.5L17.82 15.5Q18.38 15.5 18.76 15.89Q19.15 16.27 19.15 16.82Q19.15 17.38 18.76 17.76Q18.38 18.15 17.82 18.15Z" fill={color} />
    </svg>
  );
}
